import CaseData from "./component";
export default CaseData;
